import React, { useState, useContext } from "react";
import Moment from "moment";

import { IComment, ICommentApiResponse } from "../../lib/models/IComment";

import { editComment, deleteComment } from "../../lib/api/commentsApi";
import { CommentsContext } from "./CommentsContext";

interface IProps {
  data: IComment;
}

const CommentItem = ({ data }: IProps) => {
  const context = useContext(CommentsContext);
  const [showEdit, setShowEdit] = useState(false);
  const [commentBody, setCommentbody] = useState(data.body);
  const [editBody, setEditBody] = useState(data.body);
  const [response, setResponse]: [
    ICommentApiResponse,
    React.Dispatch<ICommentApiResponse>
  ] = useState(null);

  const handleCancel = () => {
    setShowEdit(false);
    setEditBody(data.body);
    setResponse(null);
  };

  const handleUpdate = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    editComment(data.id, editBody)
      .then((e) => e.json())
      .then((e: ICommentApiResponse) => {
        if (e.errors === null) {
          setShowEdit(false);
          setCommentbody(e.data.body);
        }
        setResponse(e);
      });
  };

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (confirm("Are you sure you want to delete this comment?")) {
      deleteComment(data.id)
        .then((e) => e.json())
        .then((e: ICommentApiResponse) => {
          if (e.errors === null) {
            return context.deleteComment(e.data.id);
          }
          setResponse(e);
        });
    }
  };

  return (
    <div id={data.id} className="comments__comment">
      {/* Heading */}
      <div className="row">
        <div className="comments__comment__heading__image">
          <img src="/Static/images/user_quote.svg" alt={data.authorName} />
        </div>
        <div className="comments__comment__heading__name">
          <h4>{data.authorName}</h4>
          <p>
            {Moment(new Date(data.dateCreated)).format(
              "MMM D, YYYY [at] hh:mm"
            )}
          </p>
        </div>
        <div className="comments__comment__heading__controls">
          {data.canEdit && (
            <button
              name="edit"
              className={`btn__mini btn__mini--edit ${showEdit
                && "btn__mini--active"}`}
              aria-label="Edit"
              onClick={() => setShowEdit(!showEdit)}
            ></button>
          )}
          {data.canDelete && (
            <button
              name="delete"
              className="btn__mini btn__mini--delete"
              aria-label="Delete"
              onClick={handleDelete}
            ></button>
          )}
        </div>
      </div>

      {/* Comment Body */}
      <div className="comments__comment__body">
        {/* If they can edit and the state is set to visible... */}
        {!showEdit && <p>{commentBody}</p>}
        {data.canEdit && showEdit && (
          <form className="EPiServerForms" id={data.id}>
            <div className="Form__Element">
              <textarea
                cols={20}
                maxLength={280}
                rows={5}
                value={editBody}
                onChange={(e) => setEditBody(e.currentTarget.value)}
              ></textarea>
            </div>
            <button onClick={handleUpdate} className="btn-primary mr-2">
              Save comment
            </button>
            <button onClick={handleCancel} className="btn-secondary">
              Cancel
            </button>
            <span className="comments__box__errors">
              {/* Error Messages */}
              {response?.errors?.map((e, i) => (
                <div
                  key={i}
                  className="comments__box__notes comments__box__notes--error"
                >
                  <p>{e}</p>
                </div>
              ))}
            </span>
          </form>
        )}
      </div>
    </div>
  );
};

export default CommentItem;
